<template>
  <div class="new_company_modal">
    <UeModal name="new_company_modal" width="50%" title="Create Company">
      <div class="modal_body">
        <div class="mb-5">
          <div class="row">
            <div class="col">
              <TextInput
                name="company_name"
                v-model="company.name"
                placeholder="Company Name"
                validation="required|min:2"
              />
            </div>
            <div class="col">Make sure this company doesn't already exist.</div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <TextInput
              name="domain_name"
              v-model="domain.name"
              placeholder="Domain Name"
              validation="required|min:2"
            />
          </div>
          <div class="col">
            This should be just the domain name, no transport or subdomain. AKA 'google.com'. Not
            'https://www.google.com'
          </div>
        </div>
      </div>
      <div class="modal_footer">
        <button class="btn btn-primary" @click="create()">Create Company</button>
      </div>
    </UeModal>
  </div>
</template>

<script lang="ts">
import axios from '@lib/apiClient'
import TextInput from '@/app/components/TextInput.vue'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  components: { TextInput },
  data() {
    return {
      company: {},
      domain: {},
    }
  },
  methods: {
    create() {
      this.$validator.validate().then((result) => {
        if (result) {
          axios.post('/admin/api/companies.json', { company: this.company }).then((c) => {
            axios
              .post('/admin/api/domains.json', {
                domain: Object.assign(this.domain, { company_id: c.data.company.id }),
              })
              .then(() => {
                this.$closeModal('new_company_modal')
                this.$router.push(`/admin/companies/${c.data.company.id}/edit`)
              })
          })
        }
      })
    },
  },
}
</script>
